/**
 * @module root/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
export const REPPROFILE_CONSTANTS = {
  ONE_MS: 10000000,
  EPOCH_DATE: 11644473600,
  MILLISECONDS_PER_SECOND: 1000,
  SECONDS_PER_HOUR: 3600,
  HOURS_PER_DAY: 24,
  PRIMARY_BUTTON_CLASS: 'btn btn-primary',
  SECONDRY_BUTTON_CLASS: 'btn btn-secondary',
  CLOSE_BUTTON_ID: 'closeButton',
  RETRY_BUTTON_ID: 'retryButton',
  PRIMARY_BUTTON_TYPE: 'primary',
  SECONDRY_BUTTON_TYPE: 'secondary',
};
